
























import { Vue, Component } from 'vue-property-decorator';
import Asignacion from '@/pantallas/AsignacionMandante/Asignacion.vue';

@Component({
  components: { Asignacion },
})
export default class AsignacionMandantePantalla extends Vue {}
